import React, {Component} from "react";
import {Modal} from "react-bootstrap";
import axios from "axios";
import {RESOURCE_BASE_URL} from "../../../configuration";

class StatusChange extends Component {
    constructor(props) {
        super(props);


        this.state = {
            show: false,
            showSuccess:false,
            showError:false,
            orderData: []
        };

        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.changeStatusToShipped = this.changeStatusToShipped.bind(this);
    }

    handleClose = () => {
        this.setState({
            show: false,

        });
    };
    handleCloseSuccess = () => {
        this.setState({
            showSuccess: false,
            show: false
        });
        // this.props.getAllProduction()
        window.location.reload();
    };
    handleCloseError = () => {
        this.setState({
            showError: false,

        });
    };

    handleShow = () => {
        axios.get(RESOURCE_BASE_URL + 'api/order/' + this.props.orderId)
            .then((res) => {
                this.setState({
                    orderData: res.data.items
                });
                // console.log("res.data",res.data);
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);

            });
        this.setState({
            show: true,
        });

    };

    changeStatusToShipped = () => {
        axios.get(RESOURCE_BASE_URL + 'api/order/changeStatus/' + this.props.orderId)
            .then((res) => {
                // console.log("res.data",res.data);
                this.setState({
                    showSuccess:true
                });

            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
                this.setState({
                    showError:true
                });

            });
    };

    render() {
        // console.log("order items",this.state.orderData)
        let emptyCode=false;
        return (
            <span>
                {/*<br/>*/}
                <a className="btn btn-xs btn-success" onClick={this.handleShow} id="change-status-btn-product">

                     ステータス変更
                    {/*出荷*/}
                </a>

                <Modal show={this.state.show} onHide={this.handleClose} dialogClassName="view-inquiry-modal">
                    <Modal.Header closeButton>
                        <div className="title-1 color-text resp-production">
                            ステータスを出荷済みに変更 <br/> {this.props.batchNumber}
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row color-text resp-production-content">
                            <div className="col-md-offset-1">
                                <h5 className="resp-content-h5">
                                    注文 {this.props.batchNumber} ステータスを出荷済みに変更されます。
                                </h5>
                                {this.state.orderData.map(item => {
                                    // console.log("items in production",item);
                                    if(item.productBarcode==null){
                                        emptyCode=true;
                                    }
                                    return <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        <li>{item.generatedBarcode}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        {item.productBarcode==null ?
                                            <text id="no-barcode-txt2">-無し-</text>:<text>{item.productBarcode}</text>
                                        }</li>
                                    </div>
                                })}
                            </div>

                            {emptyCode===true &&
                            <div className="col-md-offset-1">
                                <h5 id="no-barcode-txt">一部のアイテムには佐川番号が追加されていません。ステータスを変更する前に入力してください。</h5>
                            </div>
                            }
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        {emptyCode===true ?
                        <button className="btn btn-success" disabled={true}>登録</button>:<button className="btn btn-success" onClick={this.changeStatusToShipped}>登録</button>

                        }
                        <button className="btn btn-primary" onClick={this.handleClose}>キャンセル</button>
                    </Modal.Footer>
                </Modal>
                <Modal show={this.state.showSuccess} onHide={this.handleCloseSuccess} dialogClassName="view-inquiry-modal">
                    <Modal.Body>
                        <div className="spacer"></div>

                        <div className="col-md-offset-1">
                            ステータスが正常に変更されました。
                        </div>
                        <div className="spacer"></div>
                    </Modal.Body>
                     <Modal.Footer>
                        <button className="btn btn-primary" onClick={this.handleCloseSuccess}>閉じる</button>
                     </Modal.Footer>

                </Modal>
                <Modal show={this.state.showError} onHide={this.handleCloseError} dialogClassName="view-inquiry-modal">
                    <Modal.Body>
                        <div className="spacer"></div>
                        <div className="col-md-offset-1">
                            ステータスの変更中にエラーが発生しました。
                        </div>
                        <div className="spacer"></div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-primary" onClick={this.handleCloseError}>閉じる</button>
                    </Modal.Footer>
                </Modal>
            </span>
        )

    }
}
export default StatusChange;



// WEBPACK FOOTER //
// ./src/components/Admin/ProductionCompletionList/StatusChange.js